import React, { Component } from "react";
import Core from "Core";
import { observer } from "mobx-react";
import ErrorParser from "../../ErrorParser";

class ModelErrorAlert extends Component {
  onDismiss() {
    const { model } = this.props;
    const store = model.store;
    if (store) {
      store.lastError = null;
    }
  }

  reloadHandler() {
    const { model, stores } = this.props;
    const store = model.store;
    if (store) {
      store.fetchId(model.Id).then(() => {
        if (store.lastError) {
          const parsedError = new ErrorParser(store.lastError, stores);
          if (parsedError.isConcurrenyError) {
            store.lastError = null;
          }
        }
      });
    }
  }

  render() {
    const { model } = this.props;
    const store = model.store;

    const error = store ? store.lastError : null;

    return (
      <Core.Components.Alerts.Error
        error={error}
        onDismiss={this.onDismiss.bind(this)}
        reloadHandler={this.reloadHandler.bind(this)}
      />
    );
  }
}

export default observer(ModelErrorAlert);



// WEBPACK FOOTER //
// ./src/Core/Components/Alerts/ModelError.js